import Entities from 'STORE';

// Needs Bff implementation
async function request() {
  // try {
  //   return {};
  // } catch (error) {
  //   logger.get('API').error('spaces.updateDeepLink', error);
  // }
  return null;
}

export async function updateDeepLink(spaceId) {
  const space = await request(spaceId);

  if (space) {
    Entities.spacesStore.updateSpace(space);
  }

  return space;
}
